import ManaWidget from './ManaWidget'
export default ManaWidget
